/* src/app/admin-dashboard/delivery/issues/issues.component.css */
.di-wrap {
  padding: 16px;
  max-width: 860px;
}
.di-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.di-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 560px;
}
.di-tabs {
  display: flex;
  gap: 8px;
}
.di-tab-on {
  background: #eef5ff !important;
  border-color: #c9dcf7 !important;
}
.di-count {
  display: inline-block;
  min-width: 20px;
  text-align: center;
  margin-left: 6px;
  background: #fdecea;
  color: #c0392b;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
  padding: 1px 6px;
}
.di-empty {
  padding: 28px;
  text-align: center;
  color: #888;
  font-size: 13px;
}
.di-issue {
  border: 1px solid #e3e6ea;
  border-radius: 8px;
  background: #fff;
  padding: 12px 14px;
  margin-bottom: 10px;
}
.di-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}
.di-system {
  font-weight: 600;
  font-size: 14px;
}
.di-chip {
  border-radius: 12px;
  padding: 3px 9px;
  font-size: 12px;
  font-weight: 600;
  background: #fdecea;
  color: #c0392b;
}
.di-when {
  margin-left: auto;
  color: #888;
  font-size: 12px;
  white-space: nowrap;
}
.di-note-text {
  font-size: 14px;
  margin: 6px 0 2px;
}
.di-meta {
  color: #888;
  font-size: 12px;
}
.di-resolved {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 13px;
}
.di-actions {
  margin-top: 8px;
}
.di-resolve-panel {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 6px;
  flex-wrap: wrap;
}
.di-resolution {
  flex: 1 1 320px;
}
.di-resolution .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
/*# sourceMappingURL=issues.component.css.map */
